import React from "react";
import ProcedFiscal from "../components/fiscales/regProcedFiscal";
function ProcedimientoFiscal() {
  return <ProcedFiscal />;
}

export default ProcedimientoFiscal;



// WEBPACK FOOTER //
// ./src/pages/procedimientoFiscal.js